module.exports = __webpack_public_path__ + "media/images/webpage/specials/huistenbosch_2020/cover-4-46d045c2d2632fb62375e52117b2389f.webp";